module.exports = __webpack_public_path__ + "img/intro.25f3a1a6.png";